import * as ExcelJS from 'exceljs';
import { downloadBlobAsFile } from './generateTemplateCsv';

export type CellValue = string | number | boolean | null | undefined;
export type XLSXRow = CellValue[];

interface Props {
  rows: XLSXRow[];
  fileName: string;
}

export const generateXLSX = async ({ rows, fileName }: Props) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet();

  // Add each row manually to ensure text format
  rows.forEach((row) => {
    const formattedRow = row.map((cell) => (cell ? String(cell) : ''));
    worksheet.addRow(formattedRow);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });

  downloadBlobAsFile(blob, `${fileName}.xlsx`);
};
